define('controllers/membersearch',['require'],function(require) {
    return function() {
        $(function () {
            var warningmsg = "Make sure the caller is who they say they are (for example, verify they know their AMIN).";
            $('.btnPasswordResetMemberSearch').on("click", function () { return confirm(warningmsg); });
            $(".btnUnlockUser").on("click", function () { return confirm(warningmsg); });

            $("#hidden_link").fancybox({ autoSize: true }).trigger('click');
        });
    };
});
